import React from "react"
import styled from "styled-components"
import GridContainer from "@/components/common/GridContainer"
import Statistic from "@/components/Stats/Statistic"
import { getCssSizeValue } from "@/utils/utils"
import StatsLine from "@/components/Stats/Line"
import Text from "@/components/common/Text"
import { useIsMobile } from "@/hooks/useDevice"
import { BREAKPOINTS } from "@/styles/themeSettings"

const Wrapper = styled(GridContainer)`
	--bottom: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};
	position: relative;

	//Mobile
	@media (max-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET] - 1}px) {
		grid-template-columns: 1fr;
		row-gap: var(--mobile-row-gap);
	}

	//Tablet
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		--bottom: ${getCssSizeValue(170)};
	}

	//Desktop
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		--bottom: ${getCssSizeValue(32)};
	}
`
const Line = styled(StatsLine)`
	position: absolute;
	left: 0;
	bottom: var(--bottom);

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		right: 0;
	}
`
const Name = styled(Text)`
	right: var(--paddingX);
	margin-left: auto;
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		right: 0;
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		position: absolute;
		bottom: calc(var(--bottom) + ${getCssSizeValue(15)});
	}
`

const StatisticGroup = ({ data }) => {
	const id = `statistic-group-${data?.id || ""}`
	const statistics = data?.items || []
	const name = data?.name || []
	const isMobile = useIsMobile()
	return (
		<Wrapper id={id} className="col-mobile-8  col-desktop-16 no-margin">
			{statistics.map((item, index) => (
				<Statistic data={item} key={item?.id || index} line={isMobile} />
			))}
			{!isMobile && <Line />}
			<Name className="typo-borna-47 col-mobile-8">{name}</Name>
		</Wrapper>
	)
}

export default StatisticGroup
